'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'user-robot';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e04b';
var svgPathData = ['M32 192c0 13.3 10.7 24 24 24l24 0 0-48-24 0c-13.3 0-24 10.7-24 24zm72 280l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zM200 24l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm0 448l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm96 0l0 40 48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24zm72-304l0 48 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24 0z', 'M80 128c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64l0 112c0 35.3-28.7 64-64 64l-160 0c-35.3 0-64-28.7-64-64l0-112zM0 448c0-53 43-96 96-96l256 0c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32l-72 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-48 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-72 0c-17.7 0-32-14.3-32-32l0-32zM192 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserRobot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;